import Vue from 'vue'
import App from './App'
import store from '@/store'
import i18n from '@/lang'
import * as svgicon from 'vue-svgicon'
import iDalgoModules from 'idalgo-components/lib/iDalgoModules.common.js'
import 'idalgo-components/lib/iDalgoTheme/index.css'
import 'idalgo-components/lib/iDalgoTheme/modules.css'
import '@/services/iframe'
import '@/assets/fonts/fonts.scss'
import '@/components/icons'
import { Loading } from 'element-ui'

Vue.config.productionTip = false
Vue.use(svgicon)
Vue.use(Loading)
Vue.use(iDalgoModules)

new Vue({
  el: '#app',
  store,
  i18n,
  render: h => h(App)
})
